import React, { Component } from 'react';
import { Layout, Menu, Card } from 'antd';
// import SettingThesaurus from "./components/settingThesaurus";
// import SettingCheckItem from "./components/settingCheckItem";
// import SettingTemplate from "./components/settingTemplate";
import SettingConfig from "./components/settingConfig";
import EditPassWord from "./components/editPassWord";
import PatientSource from "./components/patientSource";
import CheckChildType from "./components/checkChildType";
import CheckProject from "./components/checkProject";
import CheckType from "./components/checkType";
import QualityControlSet from "./components/qualityControlSet";
import OtherSetting from './components/otherSetting'
import LogManage from './components/logManage'
import './systemSetting.scss';

const { Sider, Content } = Layout;

class SystemSetting extends Component {
  state = {
    selectedMenu: '4'
  }

  handleSelectMenu = (e) => {
    this.setState({
      selectedMenu: e.key
    })
  }

  render() {
    const { selectedMenu } = this.state
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    return (
      <>
        <Layout className="pageWrap" style={{ minWidth: '1124px' }}>
          <Sider className="siderWrap" theme="light" trigger={null}>
            <Card className="doubleBox paddingB" size="small" title={<p style={{ display: 'flex', alignItems: 'center' }}><img alt="" style={{ width: '18px', height: '18px', marginRight: '8px' }} src={require("@/assets/image/j.png").default} />系统配置</p>} style={{ width: 300 }}>
              <Menu className="menuWrap" mode="inline" onClick={this.handleSelectMenu} selectedKeys={[selectedMenu]}>
                {/* <Menu.Item key="1">
                  <span>词库管理</span>
                </Menu.Item>
                <Menu.Item key="2">
                  <span>检查项目管理</span>
                </Menu.Item>
                <Menu.Item key="3">
                  <span>自定义模板管理</span>
                </Menu.Item> */}
                <Menu.Item key="4">
                  <span>本地配置</span>
                </Menu.Item>
                <Menu.Item key="5">
                  <span>修改密码</span>
                </Menu.Item>
                {userInfo.HOSPITAL_UID === 'PLATFORM' ?
                  <Menu.Item key="6">
                    <span>患者来源</span>
                  </Menu.Item> : null}

                {/* <Menu.Item key="7">
                    <span>检查类型</span>
                  </Menu.Item>  */}
                {userInfo.HOSPITAL_UID === 'PLATFORM' ?
                  <Menu.Item key="9">
                    <span>检查子类</span>
                  </Menu.Item> : null}
                {userInfo.HOSPITAL_UID === 'PLATFORM' ?
                  <Menu.Item key="8">
                    <span>检查项目</span>
                  </Menu.Item> : null}
                {userInfo.HOSPITAL_UID === 'PLATFORM' ?
                  <Menu.Item key="10">
                    <span>质控设置</span>
                  </Menu.Item> : null}
                {userInfo.HOSPITAL_UID === 'PLATFORM' ?
                  <Menu.Item key="11">
                    <span>其他配置</span>
                  </Menu.Item>
                  : null}
                <Menu.Item key="12">
                  <span>日志管理</span>
                </Menu.Item>
              </Menu>
            </Card>
          </Sider>
          <Layout>

            {/* Content 内容部分 */}
            <Content className="contentWrap">

              {/* 词库管理 */}
              {/* {selectedMenu === '1' ? <SettingThesaurus /> : null} */}

              {/* 检查项目管理 */}
              {/* {selectedMenu === '2' ? <SettingCheckItem /> : null} */}

              {/* 自定义模板管理 */}
              {/* {selectedMenu === '3' ? <SettingTemplate /> : null} */}

              {/* 本地配置 */}
              {selectedMenu === '4' ? <SettingConfig getMessageFn={this.props.getMessageFn} /> : null}
              {/* 修改密码 */}
              {selectedMenu === '5' ? <EditPassWord /> : null}
              {/* 患者来源 */}
              {selectedMenu === '6' && userInfo.HOSPITAL_UID === 'PLATFORM' ? <PatientSource /> : null}
              {/* 检查类型 */}
              {selectedMenu === '7' && userInfo.HOSPITAL_UID === 'PLATFORM' ? <CheckType /> : null}
              {/* 检查项目 */}
              {selectedMenu === '8' && userInfo.HOSPITAL_UID === 'PLATFORM' ? <CheckProject /> : null}
              {/* 检查子类 */}
              {selectedMenu === '9' && userInfo.HOSPITAL_UID === 'PLATFORM' ? <CheckChildType /> : null}
              {/* 质控设置 */}
              {selectedMenu === '10' && userInfo.HOSPITAL_UID === 'PLATFORM' ? <QualityControlSet /> : null}
              {/* 质控设置 */}
              {selectedMenu === '11' && userInfo.HOSPITAL_UID === 'PLATFORM' ? <OtherSetting /> : null}
              {selectedMenu === '12' ? <LogManage /> : null}
            </Content>
          </Layout>
        </Layout>
      </>
    )
  }
}

export default SystemSetting;